/**
 * Strips null bytes and control characters from extracted resume text.
 * PDF/DOC parsers often emit these and they break JSON, databases, and APIs.
 */
function sanitizeResumeText(text) {
  if (!text) {
    return "";
  }

  return text
    .replace(/\u0000/g, "")
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "")
    .replace(/[^\S\n]+/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

module.exports = { sanitizeResumeText };
